import { useMemo, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { DepositIcon, RevertIcon } from "../../assets/images/svg/svg";
import {
  tableIndexNumber,
  totalPages,
  parenthesisInNegativeValue,
  HandleError,
} from "../../utils/services";
import { useBankName, useChequeList } from "../../api/get";
import { ChequeListResponse } from "../../api/types";
import { Table } from "../CustomReactTable/CustomReactTable";
import ChequeListCard from "./ChequeListCard/ChequeListCard";
import { Search } from "../../api/get/types";
import { PopupContext } from "../PopUp/Popup-Context";
import { PopUp } from "../PopUp/PopUp";
import { PasswordPopup } from "../PopUp/PasswordPopup";
import { ConfirmationPopup } from "../PopUp/ConfirmationPopup";
import { DepositSalesChequeList, RevertSalesChequeList } from "../../api/post";
import { useToast } from "../../context/ToasterContext/ToasterContext";
import { DepositPopup } from "../PopUp/DepositPopup";
import { NoDataPage } from "../NoDataPage/NoDataPage";
import { Loader } from "../Loader/Loader";

interface ViewAlProps {
  viewAll: boolean;
}
type PopUpTypes = "cancel" | "deposit";

export const ChequeList: React.FC<ViewAlProps> = ({ viewAll }) => {
  const [queryPageIndex, setQueryPageIndex] = useState(0);
  const [queryPageSize, setQueryPageSize] = useState(() => (viewAll ? 10 : 5));
  const [searchTerm, setSearchTerm] = useState<Search>({ cheque_no: "" });
  //useQuery
  const {
    data: chequeList,
    isLoading,
    refetch,
  } = useChequeList(queryPageIndex, queryPageSize, searchTerm as Search);
  const { openModal, closeModal } = useContext(PopupContext);
  const [cancelPopup, setCancelPopUp] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [bank, setBank] = useState(0);
  const [popupType, setPopupType] = useState<PopUpTypes>();
  const [passwordPopup, setPasswordPopup] = useState(false);
  const [showDepositPopup, setShowDepositPopup] = useState(false);
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const { showErrorMessage, showSuccessMessage } = useToast();
  const { data: bankNameList } = useBankName();
  /// remove date because date is not set anywhere

  const handleRevertPopup = (value: { id: string; status: string }) => {
    if (value?.status && value.status.toLowerCase() === "deposit pending") {
      openModal();
      setCancelPopUp(false);
      setShowDepositPopup(false);
      setPasswordPopup(true);
      setSelectedId(value.id);
      setPopupType("cancel");
    }
  };
  const handleDepositPopup = (value: { id: string; status: string }) => {
    if (value?.status && value.status.toLowerCase() === "deposit pending") {
      openModal();
      setCancelPopUp(false);
      setShowDepositPopup(false);
      setPasswordPopup(true);
      setSelectedId(value.id);
      setPopupType("deposit");
    }
  };

  const FormatTable = (
    array: ChequeListResponse[],
    pageIndex: number,
    pageSize: number,
  ) => {
    if (array) {
      const formatData = array?.map((item, index) => {
        return {
          s_n: tableIndexNumber(pageIndex, pageSize, index),
          date: item?.miti,
          cheque_no: item?.cheque_no,
          document_number: item?.document_number,
          name: item?.user_info?.name ? item?.user_info?.name : "-",
          mobile_no: item?.user_info?.mobile_no
            ? item?.user_info?.mobile_no
            : "-",
          amount: parenthesisInNegativeValue(item?.amount),
          status: item.status,
          action: {
            id: item.document_number,
            status: item.status,
          },
        };
      });
      return formatData;
    }
    return [];
  };
  const columns = useMemo(
    () => [
      {
        Header: "S.N",
        accessor: "s_n",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      { Header: "Cheque No", accessor: "cheque_no" },
      { Header: "Bill No", accessor: "document_number" },
      {
        Header: "Patron Name",
        accessor: "name",
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_no",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }: { value: string }) => {
          return (
            <div className={`status-section ${value.toLowerCase()}`}>
              {value}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({
          value,
        }: {
          value: {
            id: string;
            status: string;
          };
        }) => {
          return (
            <div className="action-section">
              <div
                className={
                  value?.status &&
                  value.status.toLowerCase() === "deposit pending"
                    ? "action-btn line-primary gap-2"
                    : "action-btn line-default gap-2"
                }
              >
                {value.status.toLowerCase() === "deposit pending" ? (
                  <>
                    <span
                      onClick={() => {
                        handleDepositPopup(value);
                      }}
                    >
                      <DepositIcon /> Deposit
                    </span>
                    <span
                      onClick={() => {
                        handleRevertPopup(value);
                      }}
                    >
                      <RevertIcon /> Revert
                    </span>
                  </>
                ) : (
                  <span>
                    <RevertIcon /> Revert
                  </span>
                )}
              </div>
            </div>
          );
        },
      },
    ],
    [],
  );

  const billCancelation = (reason: string, selectedId: string) => {
    if (!reason) {
      showSuccessMessage("Please specify reason");
      closeModal();

      return;
    }
    const data = {
      reason_to_revert: reason,
    };
    const PostApi = RevertSalesChequeList;
    PostApi(selectedId, data)
      .then((res) => {
        showSuccessMessage("Sales Cheque cancelled successfully");
        refetch();
        closeModal();
      })
      .catch((err) => {
        let erroMessage = "";
        if (err.response.data) {
          erroMessage = HandleError(err);
        }
        showErrorMessage(erroMessage || "Something went wrong");
      });
  };

  const handleDeposit = () => {
    if (!bank) {
      showSuccessMessage("Please specify reason");
      closeModal();
      return;
    }
    const data = {
      bank_ledger_id: Number(bank),
      description: description,
    };

    const PostApi = DepositSalesChequeList;
    PostApi(selectedId, data)
      .then((res) => {
        showSuccessMessage("Sales Cheque deposited successfully");
        refetch();
        closeModal();
      })
      .catch((err) => {
        let erroMessage = "";
        if (err.response.data) {
          erroMessage = HandleError(err);
        }
        showErrorMessage(erroMessage || "Something went wrong");
      });
  };

  return (
    <>
      <div className="dashboard-table card-height">
        {!viewAll ? (
          <>
            {isLoading ? (
              <Loader loaderType="Spinner" />
            ) : chequeList && chequeList?.data.length > 0 ? (
              <>
                {chequeList?.data
                  ?.slice(0, 3)
                  ?.map((item: any, index: number) => (
                    <ChequeListCard
                      document_number={item?.document_number}
                      cheque_no={item?.cheque_no}
                      miti={item?.miti}
                      logo={item?.user_info?.name?.slice(0, 1)}
                      name={item?.user_info?.name}
                      mobile={item?.user_info?.mobile_no}
                      amount={item?.amount}
                      status={item?.status}
                      isPurchasePayment={false}
                      handleDepositPopup={() => {
                        const value = {
                          id: item?.document_number,
                          status: item?.status,
                        };
                        handleDepositPopup(value);
                      }}
                      handleRevertPopup={() => {
                        const value = {
                          id: item?.document_number,
                          status: item?.status,
                        };
                        handleRevertPopup(value);
                      }}
                    />
                  ))}
                <Link to={`/cheque-list`} className="view-btn">
                  <button
                    type="button"
                    className="content light-secondary next small-button "
                  >
                    View All
                  </button>
                </Link>
              </>
            ) : (
              <NoDataPage description="Looks like there are no entries here yet" />
            )}
          </>
        ) : (
          <>
            <div className="head-section">
              <p className="small-title">Sales Cheque List</p>
            </div>
            <Table
              excelDownload={true}
              loading={isLoading}
              columns={columns}
              data={
                chequeList
                  ? FormatTable(chequeList.data, queryPageIndex, queryPageSize)
                  : []
              }
              totalPages={
                chequeList &&
                totalPages(queryPageSize, chequeList.pagination.total_count)
              }
              totalEntries={chequeList && chequeList.pagination.total_count}
              queryPageIndex={queryPageIndex}
              setQueryPageIndex={setQueryPageIndex}
              queryPageSize={queryPageSize}
              setQueryPageSize={setQueryPageSize}
              showPageSize={false}
              searchArray={["cheque_no"]}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </>
        )}
      </div>
      {passwordPopup && (
        <PopUp
          title="Sign-In Required"
          showCrossIcon={true}
          renderComponent={
            <PasswordPopup
              setPasswordPopup={setPasswordPopup}
              setCancelPopUp={setCancelPopUp}
            />
          }
        />
      )}
      {showDepositPopup && (
        <>
          <PopUp
            title="Deposit Cheque"
            renderComponent={
              <DepositPopup
                setDescription={setDescription}
                handleDeposit={handleDeposit}
                bankList={bankNameList}
                setBank={setBank}
              />
            }
          />
        </>
      )}
      {cancelPopup && (
        <>
          <PopUp
            title="Confirmation"
            renderComponent={
              <ConfirmationPopup
                handleCancel={() => {
                  billCancelation(reason, selectedId as string);
                  setCancelPopUp(false);
                }}
                showReasonField={true}
                reason={reason}
                setReason={setReason}
                confirmationQuestion={`Are you sure you want to cancel ${
                  selectedId || ""
                }?`}
              />
            }
          />
        </>
      )}
    </>
  );
};
